import React, { useEffect, useState } from 'react';
import { StyledNGPointsToolTip } from './NGPointsToolTip.styles';
import { NGPointsToolTipProps } from './NGPointsToolTip.types';
import { Heading, Types, Text } from '@marriott/mi-ui-library';
import clsx from 'clsx';

export const NGPointsToolTip = ({
  customClass = '',
  autoCloseSeconds,
  toolTipOpenDelay,
  onClose,
  pointsToolTipCTALabel,
  pointsToolTipMessage,
  pointsToolTipTitle,
}: NGPointsToolTipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      setIsVisible(true);
      return;
    }

    let openTimer: number | undefined;
    let closeTimer: number | undefined;
    const openDelayMs = toolTipOpenDelay && toolTipOpenDelay > 0 ? toolTipOpenDelay * 1000 : 0;
    const closeDelayMs = autoCloseSeconds && autoCloseSeconds > 0 && onClose ? autoCloseSeconds * 1000 : 0;

    const showTooltip = () => {
      setIsVisible(true);
      if (closeDelayMs && onClose) {
        closeTimer = window.setTimeout(() => {
          onClose();
        }, closeDelayMs);
      }
    };

    if (openDelayMs) {
      setIsVisible(false);
      openTimer = window.setTimeout(showTooltip, openDelayMs);
    } else {
      showTooltip();
    }

    return () => {
      if (openTimer) {
        window.clearTimeout(openTimer);
      }
      if (closeTimer) {
        window.clearTimeout(closeTimer);
      }
    };
  }, [autoCloseSeconds, onClose, toolTipOpenDelay]);

  return (
    <StyledNGPointsToolTip>
      <div className={clsx('row', 'ng-points-tooltip-row', !isVisible && 'ng-points-tooltip-hidden')}>
        <div className={clsx(customClass, 'm-popover-bottom', ' inverse')} data-content="Inverse Theme">
          <div className="m-popover-header">
            <Heading
              variation={Types.headingType.subtitle}
              fontSize={Types.size.large}
              titleText={pointsToolTipTitle}
              customClass={clsx('t-subtitle-l', 'mb-0')}
            />
          </div>
          <Text
            element={Types.tags.paragraph}
            fontSize={Types.size.extraSmall}
            copyText={pointsToolTipMessage}
            customClass={clsx('t-font-xs', 'mb-0')}
          />
          <button
            type="button"
            className={clsx('m-popover-link', 'm-button', 'tooltip-cta-class', 'p-0')}
            onClick={event => {
              event.stopPropagation();
              onClose?.();
            }}
          >
            <div className="m-icon-text">
              <span className="icon-check icon-m"></span>
              <Text
                element={Types.tags.span}
                fontSize={Types.size.small}
                copyText={pointsToolTipCTALabel}
                customClass={clsx('t-font-s', 'mb-0')}
              />
            </div>
          </button>
        </div>
      </div>
    </StyledNGPointsToolTip>
  );
};
